import React from 'react';
import { ArrowRight } from 'lucide-react';

interface UpsellFinalCtaProps {
  onNavigate: (page: string) => void;
}

export const UpsellFinalCta: React.FC<UpsellFinalCtaProps> = ({ onNavigate }) => {
  const handleScrollToTable = () => {
    const el = document.getElementById('feature-comparison');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="mb-16">
      <div className="cognitive-adapt-card text-center">
        <h2 className="text-3xl font-bold text-slate-900 dark:text-white mb-4">
          Ready to read faster?
        </h2>
        <p className="text-lg text-slate-600 dark:text-slate-400 mb-8 max-w-2xl mx-auto">
          Join thousands of readers who've already upgraded.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button
            onClick={() => onNavigate('/signup')}
            className="inline-flex items-center gap-2 px-8 py-4 text-lg font-semibold text-white bg-gradient-to-r from-blue-600 to-indigo-600 rounded-full hover:from-blue-700 hover:to-indigo-700 transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
          >
            Create Member Account
            <ArrowRight className="w-5 h-5" />
          </button>
          <button
            onClick={handleScrollToTable}
            className="text-blue-600 dark:text-blue-400 hover:underline font-medium text-sm"
          >
            View full feature comparison
          </button>
        </div>
        <p className="text-sm text-slate-500 dark:text-slate-400 mt-6">
          No credit card required for free plan
        </p>
      </div>
    </div>
  );
};
